import { createSlice } from '@reduxjs/toolkit';
import { resetApplication } from '../application/slice';
import networkingOverviewState from './state';
export const networkingOverviewSlice = createSlice({
    extraReducers: builder => {
        builder.addCase(resetApplication, () => networkingOverviewState);
    },
    initialState: networkingOverviewState,
    name: 'networkingOverview',
    reducers: {
        errorReceiveNetworkingOverview: state => {
            state.networkingOverview = undefined;
            state.requestingNetworkingOverview = false;
        },
        failedReceiveNetworkingOverview: state => {
            state.networkingOverview = undefined;
            state.requestingNetworkingOverview = false;
        },
        receiveNetworkingOverview: {
            prepare: networkingOverview => {
                return {
                    payload: {
                        networkingOverview
                    }
                };
            },
            reducer: (state, action) => {
                const { networkingOverview } = action.payload;
                state.networkingOverview = networkingOverview;
                state.requestingNetworkingOverview = false;
            }
        },
        requestNetworkingOverview: state => {
            state.requestingNetworkingOverview = true;
        },
        resetNetworkingOverview: () => networkingOverviewState
    }
});
export const { errorReceiveNetworkingOverview, failedReceiveNetworkingOverview, receiveNetworkingOverview, requestNetworkingOverview, resetNetworkingOverview } = networkingOverviewSlice.actions;
export default networkingOverviewSlice.reducer;
